module.exports = __webpack_public_path__ + "static/media/ResourceActiveIcon.9837b1c6.svg";